import styled from "@emotion/styled";

const PlayerContent = styled.main`
  flex: 1;
  width: 100%;
  overflow: hidden;
  position: relative;
  aspect-ratio: 16 / 9;
  background: linear-gradient(135deg, #0d1b2a 0%, #1b2838 100%);

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
  }
`;

export default PlayerContent;
